(() => {
  const translations = new Map([
    ["Hiçbir öğe bulunamadı", "Henüz değerlendirme yok."],
    ["Sizin Hakkınızda", "Hakkınızda"],
    ["Görünen İsim (Gerekli)", "Görünen ad (Gerekli)"],
    ["Gizliliğinizi korumak için", "E-posta adresiniz gizli tutulur."],
    ["Bu diğer müşteriler tarafından görülmeyecek.", "Bu ad diğer müşteriler tarafından görülecektir."],
    ["İşleniyor ve yakında mağazada görünecek.", "Değerlendirmeniz incelendikten sonra mağazada yayımlanacaktır."],
    [
      "Geri bildiriminizi değerlendirir ve iyileştirmek için kullanırız. Lütfen herhangi bir fikir veya öneri paylaşın.",
      "Geri bildiriminizi deneyimi iyileştirmek için kullanırız. Fikir ve önerilerinizi paylaşabilirsiniz.",
    ],
  ]);

  function translateTextNodes(root) {
    if (!(root instanceof Element) && root !== document.body) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      const current = node.nodeValue;
      const trimmed = current.trim();
      const replacement = translations.get(trimmed);

      if (replacement) {
        node.nodeValue = current.replace(trimmed, replacement);
      }
    }
  }

  function translateReviewWidgets(root = document.body) {
    if (!root) return;

    if (root.matches?.('[class*="jdgm"], [class*="jm-"]')) {
      translateTextNodes(root);
    }

    root.querySelectorAll?.('[class*="jdgm"], [class*="jm-"]').forEach(translateTextNodes);
  }

  function start() {
    translateReviewWidgets();

    new MutationObserver((records) => {
      for (const record of records) {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) translateReviewWidgets(node);
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
